<template>
  <div style="position: relative">
    <img src="../../assets/bgt.png" style="width:100%">
    <div class="more-btn" @click="goBack">
      返回
    </div>
    <div class="update-main">
      <div class="intro">
        <img src="../../assets/update.png" alt="" style="zoom:0.4" />
          <div class="intro-text">UPDATE</div>
        </div>
        <div v-for="item in updateList" class="items-detail">
          <div class="details">
            <div style="display:flex;align-items: center">
              <div class="text-version">{{item.versionNum}}</div>
              <div>{{item.versionIntro}}</div>
            </div>
            <div>{{item.publishTime}}发布</div>
        </div>
        <div v-for="item2 in item.versionInfo" class="details-intro">
          {{ item2 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import ButtonCancel from '../../components/Button/ButtonCancel'
import ButtonAdd from '../../components/common/buttons/button-add'
import {errorHandler} from '../../utils/errorHandler'
import {api} from '../api/WorkbenchApproval'
import ButtonConfirm from '../../components/Button/ButtonConfirm'
import {nError, nSuccess} from '../../utils/notice'
import {bus} from '../../utils/bus'

export default {
  components: {
    ButtonConfirm,
    ButtonAdd,
    ButtonCancel,
    Breadcrumb},
  name: 'update-detail',
  data () {
    return {
      updateList:{}
    }
  },
  created () {
    // this.workData = this.$route.query.workData
    // this.workType = this.$route.query.workType
    this.workData = jQuery.parseJSON(sessionStorage.getItem('workDetailData'))
    this.workType = sessionStorage.getItem('workDetailActiveName')
    this.accountCode = bus.global.accountCode
    this.accountName = bus.global.accountName
    this.getVesionList()
  },
  methods: {
    getVesionList(){
      this.$axios.post(api.getVesionList,{}).then(res=>{
        this.updateList=res.data.data
        this.updateList.map(v=>{
          v.versionInfo = v.versionDes.split("\n") || [];
          v.versionIntro=v.versionName.substring(v.versionName.length-6);
          v.versionNum=v.versionName.substring(0,v.versionName.length-6);
        })
        console.log(this.updateList)
      }).catch(errorHandler("获取版本信息失败"))
    },
    goBack(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.view2{
  padding: 0 !important;
}
.update-main{
  padding: 0 300px;
}
.intro{
  display: flex;
  justify-content:start;
  align-items: center;
}
.intro-text{
  font-size: 30px;
  font-family: HuXiaoBo-NanShen;
  font-weight: 400;
  color: #1362FF;
  opacity: 1;
}
.details{
  display: flex;
  justify-content:space-between;
  align-items: center;
}
.items-detail{
  margin-top: 40px;
}
.text-version{
  color: #1362FF;
  font-size:24px
}
.details-intro{
  margin: 10px 70px;
  text-align: left;
}
.more-btn{
  width: 70px;
  height: 24px;
  background: #1362ff;
  opacity: 1;
  border-radius: 7px;
  color: #fff;
  line-height: 24px;
  cursor: pointer;
  font-size: 12px;
  position:absolute;
  top:20%;
  right:20%;
}
</style>



// WEBPACK FOOTER //
// src/view/Workbench/UpdateDetail.vue